import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { UserInterfacePluginParameters, createUIPlugin } from './ui-plugin';

interface PluginParameters {
  editing: typeof Plugin;
  name: string;
  uis: UserInterfacePluginParameters[];
}

export const createCarbonIconPlugin = ({
  editing,
  name,
  uis,
}: PluginParameters): typeof Plugin =>
  class extends Plugin {
    static get requires() {
      return [editing, ...uis.map((params) => createUIPlugin(params))];
    }

    static get pluginName() {
      return name;
    }
  };
